import { useEffect, useRef } from "react";
import { supabase } from "../lib/supabase";
import { useNavigate } from "react-router-dom";

export function useInactivityLogout(
  minutes = Number(import.meta.env.VITE_AUTO_LOGOUT_MIN ?? 60)
) {
  const navigate = useNavigate();
  const timerRef = useRef<number | undefined>(undefined);
  const timeoutMs = Math.max(1, minutes) * 60 * 1000;

  useEffect(() => {
    const reset = () => {
      if (timerRef.current !== undefined) window.clearTimeout(timerRef.current);
      timerRef.current = window.setTimeout(async () => {
        try { await supabase.auth.signOut(); }
        finally { navigate("/signin?m=timeout", { replace: true }); }
      }, timeoutMs);
    };

    const windowEvents: Array<keyof WindowEventMap> = [
      "mousemove","mousedown","keydown","touchstart","scroll",
    ];
    const handler: EventListener = () => reset();

    windowEvents.forEach((e) => window.addEventListener(e, handler, { passive: true }));
    document.addEventListener("visibilitychange", handler);

    reset();

    return () => {
      if (timerRef.current !== undefined) window.clearTimeout(timerRef.current);
      windowEvents.forEach((e) => window.removeEventListener(e, handler));
      document.removeEventListener("visibilitychange", handler);
    };
  }, [navigate, timeoutMs]);
}
